/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDeviceServicesListQueryResponse, StreamerBoxStreamerBoxDeviceServicesListPathParams } from "../models/StreamerBoxStreamerBoxDeviceServicesList";

export function getStreamerBoxStreamerBoxDeviceServicesListUrl(uuidOrId: StreamerBoxStreamerBoxDeviceServicesListPathParams["uuidOrId"]) {
  const res = { method: 'GET', url: `/streamer-box/devices/${uuidOrId}/services` as const }
  return res
}

/**
 * @description Returns installed services on the device (excludes downloaded or deleted images).
 * @summary List services
 * {@link /streamer-box/devices/:uuidOrId/services}
 */
export async function streamerBoxStreamerBoxDeviceServicesList(uuidOrId: StreamerBoxStreamerBoxDeviceServicesListPathParams["uuidOrId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDeviceServicesListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStreamerBoxStreamerBoxDeviceServicesListUrl(uuidOrId).url.toString(), ... requestConfig })
  return res.data
}